var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcUnlockVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    "data-name": "Component 239 \\u2013 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(240,102,73,0.1)",
    stroke: "#ec6321",
    "data-name": "Rectangle 5716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 119,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17478"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17291"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17290"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17289"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ec6321",
    d: "M37.541 8.427H7.832a4.925 4.925 0 0 0-4.924 4.925v29.714a4.925 4.925 0 0 0 4.924 4.924h29.714a4.925 4.925 0 0 0 4.925-4.924V13.352a4.925 4.925 0 0 0-4.93-4.925Zm19.51 3.884-11.29 7.794v16.214l11.29 7.778a3.303 3.303 0 0 0 5.197-2.658V14.972a3.304 3.304 0 0 0-5.195-2.661z",
    style: {
      strokeWidth: 1.62371
    },
    transform: "translate(29 34)"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17295"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ec6321",
    "data-name": "Icon ionic-ios-add-circle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.417 51.374a13.484 13.484 0 0 1-9.598-3.975 13.484 13.484 0 0 1-3.975-9.598c0-3.626 1.412-7.035 3.975-9.598a13.484 13.484 0 0 1 9.598-3.975c3.626 0 7.035 1.412 9.598 3.975a13.484 13.484 0 0 1 3.974 9.598c0 3.626-1.411 7.035-3.974 9.598a13.484 13.484 0 0 1-9.598 3.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#feefec",
    d: "M38.417 24.728c-3.493 0-6.776 1.36-9.245 3.828a12.988 12.988 0 0 0-3.828 9.245c0 3.492 1.36 6.776 3.828 9.244a12.988 12.988 0 0 0 9.245 3.829c3.492 0 6.775-1.36 9.244-3.829a12.988 12.988 0 0 0 3.828-9.244c0-3.493-1.36-6.776-3.828-9.245a12.988 12.988 0 0 0-9.244-3.828m0-1c7.774 0 14.072 6.299 14.072 14.073s-6.298 14.073-14.072 14.073c-7.774 0-14.073-6.3-14.073-14.073 0-7.774 6.299-14.073 14.073-14.073Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.51 37.979v-3.26a4.232 4.232 0 1 0-8.464 0v3.26a3.855 3.855 0 0 0 2.55 6.745h3.363a3.855 3.855 0 0 0 2.55-6.745zm-3.634 2.804.265 1.625a.874.874 0 1 1-1.727 0l.265-1.625a1.308 1.308 0 1 1 1.197 0zm-2.28-3.77a3.862 3.862 0 0 0-.969.123v-2.418a2.65 2.65 0 1 1 5.3 0v2.418a3.862 3.862 0 0 0-.968-.122z",
    "data-name": "Trac\\xE9 12134"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnlockVideo);
export default __webpack_public_path__ + "static/media/ic-unlock-video.93736e2ce5de565b98031d230eb2de44.svg";
export { ForwardRef as ReactComponent };